import React from 'react'
import classNames from 'classnames'

/**
 * Stock status icon - a filled circle within an outlined circle
 */
export const StockIcon = ({
  outOfStock,
  lowStock
}: {
  outOfStock: boolean
  lowStock?: boolean
}) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={classNames('stockIcon', { outOfStock, lowStock })}
    aria-hidden='true'
  >
    <circle
      cx='8'
      cy='8'
      r='7'
      stroke='currentColor'
      strokeWidth='1.5'
      fill='none'
    />
    <circle cx='8' cy='8' r='4' fill='currentColor' />
  </svg>
)
